import { render, staticRenderFns } from "./autoTrade.vue?vue&type=template&id=49d3522b&scoped=true"
import script from "./autoTrade.vue?vue&type=script&lang=js"
export * from "./autoTrade.vue?vue&type=script&lang=js"
import style0 from "./autoTrade.vue?vue&type=style&index=0&id=49d3522b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_cache-loader@4.1.0_webpack@4.47.0__css-load_310753db291b809859cbd9e654a8ef6f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d3522b",
  null
  
)

export default component.exports